import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useSetPin } from "../../hooks/useSecurity";
import { errorMessage } from "../../hooks/useServers";

// PIN de 6 dígitos: sirve para recuperar el acceso (junto con un código por WhatsApp o correo). Se guarda cifrado; 3 fallos bloquean 1 hora.
export function PinSection({ status }) {
  const setPin = useSetPin();
  const [open, setOpen] = useState(false);
  const [pin, setPinText] = useState("");
  const [again, setAgain] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const ready = /^\d{6}$/.test(pin) && pin === again && password.length > 0;
  const save = async () => {
    setError("");
    try {
      await setPin.mutateAsync({ pin, current_password: password });
      setOpen(false);
      setPinText("");
      setAgain("");
      setPassword("");
      setSaved(true);
    } catch (e) {
      setError(errorMessage(e, "No se pudo guardar el PIN."));
    }
  };
  return (
    <div data-testid="pin-section" className="space-y-3">
      <p data-testid="pin-state" className="text-sm">{status.pin_set ? "✅ PIN configurado" : "🟡 Sin PIN: la recuperación por WhatsApp o correo no funcionará"}{saved ? " · guardado" : ""}</p>
      {!open && <Button data-testid="pin-open" size="sm" variant="outline" onClick={() => { setSaved(false); setOpen(true); }}>{status.pin_set ? "Cambiar PIN" : "Configurar PIN"}</Button>}
      {open && (
        <div className="space-y-2 rounded-lg border border-border p-3">
          <Input data-testid="pin-input" type="password" inputMode="numeric" maxLength={6} placeholder="PIN de 6 dígitos" value={pin} onChange={(e) => setPinText(e.target.value)} className="w-48 text-center tracking-widest" />
          <Input data-testid="pin-again" type="password" inputMode="numeric" maxLength={6} placeholder="Repite el PIN" value={again} onChange={(e) => setAgain(e.target.value)} className="w-48 text-center tracking-widest" />
          <Input data-testid="pin-password" type="password" autoComplete="current-password" placeholder="Tu contraseña actual" value={password} onChange={(e) => setPassword(e.target.value)} />
          {pin && again && pin !== again && <p className="text-xs text-amber-500">Los dos PIN no coinciden.</p>}
          <div className="flex gap-2">
            <Button data-testid="pin-save" size="sm" disabled={!ready || setPin.isPending} onClick={save}>Guardar PIN</Button>
            <Button size="sm" variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button>
          </div>
        </div>
      )}
      {error && <p data-testid="pin-error" className="text-xs text-amber-500">{error}</p>}
    </div>
  );
}
